import { User } from '@/features/auth/types';

export interface CurrentUserResponse {
  name: string | null;
  claims: { type: string; value: string }[];
}

const claimValue = (response: CurrentUserResponse, type: string) =>
  response.claims.find(claim => claim.type === type)?.value ?? '';

export const toUser = (response: CurrentUserResponse): User => {
  const userName = response.name ?? claimValue(response, 'name');
  const firstName = claimValue(response, 'given_name');
  const middleName = claimValue(response, 'middle_name');
  const lastName = claimValue(response, 'family_name');

  return {
    id: claimValue(response, 'sub'),
    userName,
    email: claimValue(response, 'email') || userName,
    emailConfirmed: claimValue(response, 'email_verified') === 'true',
    firstName,
    middleName,
    lastName,
    fullName:
      [lastName, firstName, middleName].filter(Boolean).join(' ') || userName,
    phoneNumber: null,
    roles: response.claims
      .filter(claim => claim.type === 'role')
      .map(claim => claim.value),
  };
};
